// extracted by mini-css-extract-plugin
module.exports = {"mainWindow":"style_mainWindow__hcelm"};